import { useCallback, useState } from 'react';
import { httpsCallable } from 'firebase/functions';

import { functions } from '../utils/firebase';

const SET_REVIEW_REACTION = 'callableReviewSetReviewReaction-setReviewReaction';

export function useReviewReactionMutation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = useCallback(async ({
    reviewType,
    reviewId,
    reactionType,
    actorType,
    actorId,
  }) => {
    setLoading(true);
    setError(null);
    try {
      const callable = httpsCallable(functions, SET_REVIEW_REACTION);
      const result = await callable({
        reviewType,
        reviewId,
        reactionType,
        actorType,
        actorId,
      });
      return result.data;
    } catch (mutationError) {
      setError(mutationError);
      throw mutationError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { mutate, loading, error };
}

export default useReviewReactionMutation;
